import { EditorLabelPosition, RichEdit } from '@powerportalspro/react-fluent';
import { useExampleDocument } from './use-example-document';

export function RichEditMainSample() {
  useExampleDocument('ppp_richdescription');
  return <RichEdit columnName="ppp_richdescription" labelPosition={EditorLabelPosition.Above} />;
}
